import { geom } from './map-geom';
import json from '../../data/VE_gold_data.json';

const mapData = json['VE_gold_data'];

let paintStyles = {
  fill: {
    'fill-color': '#ffae00',
    'fill-outline-color': '#412d03',
    'fill-opacity': 0,
    'fill-opacity-transition': {
      delay: 250,
      duration: 250
    }
  },
  line: {
    'line-width': 5,
    'line-color': '#ffae00',
    'line-opacity': 0,
    'line-opacity-transition': {
      delay: 250,
      duration: 250
    }
  },
  sym: {
    'text-color': '#000',
    'text-halo-color': '#fff',
    'text-halo-width': 1,
    'text-halo-blur': 2,
    'text-opacity': 0,
    'text-opacity-transition': { delay: 250, duration: 250 }
  }
};

function createLayers(map) {
  mapData.forEach(d => {
    if (d.datum === 'TRUE') {
      let source = {
        type: 'geojson',
        data: geom[d.id]
      };
      map.addLayer({
        id: d.id,
        type: d.type,
        source: source,
        paint: paintStyles[d.type],
        filter: d.type === 'line' ? ['==', '$type', 'LineString'] : ['all']
      });

      if (d.type === 'line') {
        map.addLayer({
          id: `${d.id}-sym`,
          source: source,
          type: 'symbol',
          layout: {
            'text-field': '{name}',
            'text-allow-overlap': true,
            'text-size': 20,
            'text-anchor': 'top-right',
            'text-offset': [-0.5, 0.25]
          },
          paint: paintStyles.sym,
          filter: ['==', '$type', 'Point']
        });

        map.addLayer({
          id: `${d.id}-cir`,
          type: 'circle',
          source: source,
          paint: {
            'circle-radius': 8,
            'circle-color': '#f93422',
            'circle-opacity': 0
          },
          filter: ['==', '$type', 'Point']
        });
      }
    }
  });
}

export { createLayers };
